'use strict';

/* global $ */

let OMP = {
  components: {}, 
  utils: {
    getArgs: function($el) {
      try {
        return eval("(" + $el.attr("data-component-options") + ")") || {};
      } catch(ex) {
        return {};
      }
    }
  }
};

let bindComponents = function() {
    $("[data-component]").each(function() {
        let $el = $(this);
        let names = $el.attr('data-component').split(',');
        names.forEach((name) => {
          if (! (name in OMP.components)) {
            console.error(`Component "${name}" is not defined`);
            return false;
          } else {
            let existing = $el.data('data-loaded-components');
            if (!existing) {
              existing = [];
              $el.data('data-loaded-components', existing);
            }
            if (! (name in $el.data('data-loaded-components'))) {
                let options = OMP.utils.getArgs($el);
                let Constructor = OMP.components[name];
                let obj = new Constructor($el, options);
                existing.push(name);
                $el.data('data-component', obj);
                console.log(`Component "${name}" loaded.`);
            } else {
                console.log(`Component "${name}" already loaded`);
            }
          }  
        });      
    });
};

// Filter menu

OMP.components.filters = function($el, options) {
  let settings = $.extend({}, {
    parentSelector: '[data-filter-parent]',
    triggerSelector: '[data-filter-trigger]',
    parentActiveClass: 'open',
  }, options);

  let api = {};

  let $triggers = $el.find(settings.triggerSelector);

  $triggers.click(function() {
    $(this).parents(settings.parentSelector).toggleClass(settings.parentActiveClass);
    $(this).siblings('ul').slideToggle(150);
    return false;
  });

  return api;
};

// Team list

OMP.components.team = function($el, options) {
  let settings = $.extend({}, {}, options);
  let api = {};

  let list = new List($el[0], {
    listClass: 'team-list'
  });

  return api;
};

// Images

OMP.components.image = function($el, options) {
  let settings = $.extend({}, {
    fullscreenActiveClass: 'image--show-fullscreen'
  }, options);
  let api = {};

  let $fullscreen = $el.find('[data-image-fullscreen]');
  let $closeFullscreen = $el.find('[data-image-close-fullscreen]');

  if ($fullscreen.length > 0) {
    $el.on('click', function() {
      $el.addClass(settings.fullscreenActiveClass);
      return false;
    });

    $closeFullscreen.on('click', function() {
      $el.removeClass(settings.fullscreenActiveClass);
      return false;
    });

    $(document).keyup(function(e) {
      if (e.keyCode === 27) {
        $el.removeClass(settings.fullscreenActiveClass);
        return false;
      }
    });
  }

  return api;
};

// Nav

OMP.components.nav = function($el, options) {
  let settings = $.extend({}, {
    stickyThreshold: 20,
    stickyClass: 'nav-wrapper--sticky',
    showMenuClass: 'nav-wrapper--show-menu',
    overlayActiveClass: 'nav-wrapper--show-overlay',
  }, options);
  let api = {};

  let $hamburger = $el.find('[data-nav-hamburger]');
  let $overlay = $el.find('[data-nav-overlay]');
  let $overlayClose = $el.find('[data-nav-overlay-close]');

  // Stickiness

  let setStickiness = function() {
    let top = $(this).scrollTop();
    if( top > settings.stickyThreshold ) {
      $el.addClass(settings.stickyClass);
      $el.removeClass(settings.showMenuClass);
    } else {
      $el.removeClass(settings.stickyClass);
      $el.addClass(settings.showMenuClass);      
    }
  };

  $(window).on('scroll load', setStickiness);

  // Overlay

  $hamburger.on('click', function() {
    $el.addClass(settings.overlayActiveClass);
    $el.toggleClass(settings.showMenuClass);
    return false;
  });

  $overlayClose.on('click', function() {
    $el.removeClass(settings.overlayActiveClass);
    return false;
  });

  $(document).keyup(function(e) {
    if (e.keyCode === 27) {
      $el.removeClass(settings.overlayActiveClass);
      return false;
    }
  });

  return api;
};

// Sticky sidebar 

OMP.components.stickySidebar = function($el, options) {
  let settings = $.extend({}, {
    stickyMenuClass: 'sticky-sidebar--sticky',
    stickyBottomClass: 'sticky-sidebar--bottom',
    scrollOffset: 100
  }, options);
  let api = {};

  let $container = $el.parent();
  let min = $container.offset().top;
  let max = $container.offset().top + $container.height();
  
  let scrollTop,
      containerOffset,
      containerHeight,
      elOffset,
      elHeight;

  var checkStickiness = function() {
    scrollTop = $(window).scrollTop();
    containerOffset = $container.offset();
    containerHeight = $container.height();
    elOffset = $el.offset();
    elHeight = $el.height();

    if (scrollTop + settings.scrollOffset >= containerOffset.top) {
      if (scrollTop + elHeight + settings.scrollOffset > containerOffset.top + containerHeight) {
        // Bottom
        if (!$el.hasClass(settings.stickyBottomClass)) {
          $el.removeClass(settings.stickyMenuClass);
          $el.addClass(settings.stickyBottomClass);
          $el.css({top: 'auto'});
        }
      } else {
        // Sticky
        if (!$el.hasClass(settings.stickyMenuClass)) {
          $el.removeClass(settings.stickyBottomClass);
          $el.addClass(settings.stickyMenuClass);
        }
        $el.css('top', settings.scrollOffset);
      }
    } else {
      // Normal
      if ($el.hasClass(settings.stickyMenuClass)) {
        $el.removeClass(settings.stickyMenuClass);
        $el.removeClass(settings.stickyBottomClass);
        $el.css('top', 0);
      }
    }
  }

  $(window).on('scroll load', checkStickiness);

  return api;
};

// Sticky menu 

OMP.components.stickyMenu = function($el, options) {
  let settings = $.extend({}, {
    activeMenuClass: 'menu__list__link--active',
    menuItemSelector: '[data-menu-item]',
    scrollOffset: 200
  }, options);
  let api = {};

  let previousScrollTop = 0;
  let offsetsMap = {};
  let offsets = [];
  let $menuItems = $el.find(settings.menuItemSelector);  
  let $pageSections = $menuItems.map(function(i, el) {
    return $(document).find($(el).attr('href'));
  });

  $(window).on('load scroll', function() {
    let scrollTop = $(window).scrollTop();
    let min = 100000000, n, id;

    $pageSections.each(function(i, el) {
      n = $(el).offset().top - scrollTop;
      if (n > 0 && n < min) {
        min = n;
        id = $(el).attr('id');
      }
    });

    $menuItems
      .removeClass(settings.activeMenuClass)
      .filter(`[href="#${id}"]`)
      .addClass(settings.activeMenuClass);
  });
  
  return api;
};


// Smooth scroll
// 
// Works for both elements that have a href with a hash value or non-anchor
// elements with a 'data-scroll-target=#target' attribute

OMP.components.smoothScroll = function($el, options) {
  let settings = $.extend({}, {
    speed: 500,
    easing: 'swing',
    scrollOffset: 95
  }, options);
  let api = {};

  $el.on('click',function (e) {
    e.preventDefault();

    let hash;
    let attr = $el.attr('href');

    if (typeof attr !== typeof undefined && attr !== false) {
      hash = this.hash;
    } else {
      hash = $el.attr('data-scroll-target');
    }
    
    if (hash) {
      let $target = $(hash);
      $('html, body').stop().animate({
          'scrollTop': $target.offset().top - settings.scrollOffset
      }, settings.speed, settings.easing, function () {
          history.replaceState(null,null, hash);
      });
    } else {
      console.log("Couldn't find target for smooth scroll:", $el);
    }
  });

  return api;
};


// Smooth scroll

OMP.components.accordian = function($el, options) {
  let settings = $.extend({}, {
    activeClass: 'accordian__page--active',
    pageSelector: '[data-accordian-page]',
    triggerSelector: '[data-accordian-trigger]',
    contentSelector: '[data-accordian-content]'
  }, options);
  let api = {};

  let $pages = $el.find(settings.pageSelector);
  let $triggers = $el.find(settings.triggerSelector);
  
  $triggers.on('click', function() {
    let $page = $(this).parent(settings.pageSelector);
    if ($page.hasClass(settings.activeClass)) {
      $page.removeClass(settings.activeClass);
      $page.find(settings.contentSelector).slideUp(150);
      $el.trigger('closedPage', [$page]);
    } else {
      $page.addClass(settings.activeClass);
      $page.find(settings.contentSelector).slideDown(150);
      $el.trigger('openedPage', [$page]);
    }
    return false;
  });
  
  return api;
};


// Swiper

OMP.components.swiper = function($el, options) {
  let settings = $.extend({}, {}, options);
  let api = {};
  let activeClass = 'swiper-thumbnail--active';

  let $swiper = $el.find('[data-swiper]');
  let $thumbnails = $el.find('[data-thumbnail]');

  api.swiper = new Swiper ($swiper[0], {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  if ($thumbnails.length > 0) {
    $thumbnails.removeClass(activeClass);
    $thumbnails.first().addClass(activeClass);

    $thumbnails.on('click', function() {
      $thumbnails.removeClass(activeClass);
      $(this).addClass(activeClass);
      api.swiper.slideTo($(this).index());
      $(document).find('video').trigger('pause');
      return false;
    }); 
  }

  return api;
};


// Map

OMP.components.simpleMap = function($el, options) {
  let settings = $.extend({}, {
    zoom: 16
  }, options);
  let api = {};

  let lat = $el.data('lat');
  let lng = $el.data('lng'); 
  let latlng = [lat, lng];

  let map = L.map($el[0]).setView(latlng, settings.zoom);
  let icon =  L.icon({
    iconUrl: '/static/images/marker-icon.png',
    iconSize: [25,41],
    iconAnchor: [12,41],
    shadowUrl: '/static/images/marker-shadow.png',
  });
  
  L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png').addTo(map);
  L.marker(latlng, {icon: icon}).addTo(map);
  
  map.panTo(latlng);

  $el.data('leaflet', map);
  return api;
};


(function() {
  bindComponents();
})();